// extracted by mini-css-extract-plugin
export var actions = "_u3-4";
export var item = "_u3-1";
export var price = "_u3-3";
export var quantity = "_u3-2";
export var table = "_u3-0";